import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MagnifyingGlass, List, X } from '@phosphor-icons/react';
import SearchBar from './docs/SearchBar';
import { PUBLIC_ROUTES } from '../../constants/routes';
import { getMainSiteUrl, getDocsSiteUrl, getHelpSiteUrl, getApiDocsRoute, getHelpRoute } from '../../utils/navigation';
import './HelpApiNavbar.css';

/**
 * HelpApiNavbar Component
 * Custom navbar for Help Center and API Documentation pages
 * Includes logo, navigation links, search bar, and mobile menu burger
 */
const HelpApiNavbar = ({ type = 'help', onMenuToggle, isMenuOpen }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const isLocalhost = typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  const handleLogoClick = () => {
    if (isLocalhost) {
      // On localhost, use React Router for SPA navigation
      navigate(PUBLIC_ROUTES.HOME);
    } else {
      // On production subdomains, use absolute URL for cross-subdomain navigation
      window.location.href = getMainSiteUrl();
    }
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    // TODO: Implement search functionality
    console.log('Searching for:', term);
  };

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const handleMenuToggle = () => {
    if (onMenuToggle) {
      onMenuToggle();
    }
  };

  return (
    <nav className="help-api-navbar">
      <div className="help-api-navbar-container">
        {/* Logo - always visible on left */}
        <a href="/" className="help-api-navbar-logo" onClick={(e) => { e.preventDefault(); handleLogoClick(); }}>
          <img 
            src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fwesplit-logo.png?alt=media&token=4f50d17a-de63-455e-bb13-9a6950784159" 
            alt="WeSplit" 
          />
        </a>

        {/* Desktop Navigation Links */}
        <div className="help-api-navbar-nav desktop-nav">
          {isLocalhost && (
            <>
              <Link to={PUBLIC_ROUTES.HOME} className="help-api-navbar-link">Home</Link>
              <Link to={PUBLIC_ROUTES.API_DOCS_OVERVIEW} className="help-api-navbar-link">API Docs</Link>
              <Link to={PUBLIC_ROUTES.HELP} className="help-api-navbar-link">Help Center</Link>
            </>
          )}
          {!isLocalhost && (
            <>
              <a href={getMainSiteUrl()} className="help-api-navbar-link">Home</a>
              <a href={getDocsSiteUrl() + getApiDocsRoute(PUBLIC_ROUTES.API_DOCS_OVERVIEW)} className="help-api-navbar-link">API Docs</a>
              <a href={getHelpSiteUrl() + getHelpRoute(PUBLIC_ROUTES.HELP)} className="help-api-navbar-link">Help Center</a>
            </>
          )}
        </div>

        {/* Desktop Search Bar - Hidden until search is implemented */}
        {/* <div className="help-api-navbar-search desktop-search">
          <SearchBar 
            onSearch={handleSearch} 
            placeholder="Ask or search..."
          />
        </div> */}

        {/* Mobile Actions - Right side */}
        <div className="help-api-navbar-mobile-actions">
          {/* Mobile Search Icon - Hidden until search is implemented */}
          {/* <button 
            className="help-api-navbar-mobile-btn search-btn"
            onClick={toggleSearch}
            aria-label="Toggle search"
          >
            <MagnifyingGlass size={24} weight="regular" />
          </button> */}

          {/* Mobile Menu Burger */}
          <button 
            className={`help-api-navbar-mobile-btn menu-btn ${isMenuOpen ? 'open' : ''}`}
            onClick={handleMenuToggle}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? (
              <X size={24} weight="regular" />
            ) : (
              <List size={24} weight="regular" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Search Bar - Hidden until search is implemented */}
      {/* {isSearchOpen && (
        <div className="help-api-navbar-mobile-search">
          <SearchBar 
            onSearch={handleSearch} 
            placeholder="Ask or search..."
          />
        </div>
      )} */}
    </nav>
  );
};

export default HelpApiNavbar;
